/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import { Fields, Form2 } from "@cd2/forms"
import { useState } from "react"
import { useAsyncEffect } from "../../hooks/useAsyncEffect"
import { IRecord } from "../../types/schema"
import { useGlobalState } from "../GlobalStateProvider"

type ISuppliers = IRecord<"suppliers", "name" | "account_reference">

export function SupplierSelect({
  value,
  onChange,
  label,
  disabled,
  noScopeToBranch,
  isClearable,
  skeemFilter,
  error,
  required,
  branchId,
}: {
  value?: string | null
  onChange(id: string, supplier: ISuppliers): void
  label?: React.ReactNode
  disabled?: boolean
  noScopeToBranch?: boolean
  isClearable?: boolean
  skeemFilter?: any
  error?: string
  required?: boolean
  branchId?: string
}) {
  const [isLoading, setIsLoading] = useState(true)
  const skeem = window.skeem
  const { currentUser } = useGlobalState()

  const [suppliers, setSuppliers] = useState<ISuppliers[]>([])

  function handleChange(id: string) {
    console.log(id)
    onChange(id, suppliers.find(w => w.id === id)!)
  }

  useAsyncEffect(async () => {
    try {
      const suppliers = await skeem.fetch2<ISuppliers[]>({
        model: {
          name: "suppliers",
          attributes: ["name", "account_reference"],
          filter: {
            and: [
              {
                matches: {
                  branch: noScopeToBranch ? undefined : branchId ?? currentUser.branch.id,
                },
              },
              skeemFilter,
            ].filter(Boolean),
          },
          sort: { by: "name", direction: "asc" },
        },
      })
      setSuppliers(suppliers)
    } finally {
      setIsLoading(false)
    }
  }, [branchId, JSON.stringify(skeemFilter)])

  const accountRefCss = css`
    font-size: 12px;
    font-weight: 600;
    color: #999;
  `

  return (
    <Fields.Select2
      label={
        label ?? <Form2.FieldLabel fieldName="supplier" label={"Supplier"} required={required} />
      }
      options={suppliers}
      onChange={value => handleChange(value?.id)}
      value={suppliers.find(v => v.id === value)}
      getOptionLabel={opt => opt.name}
      getOptionValue={opt => opt.id}
      disabled={disabled}
      isClearable={isClearable}
      error={error}
      isLoading={isLoading}
      components={{
        SingleValue: props => {
          const { innerProps, getStyles } = props
          const supplier = props.data

          return (
            <div
              {...innerProps}
              style={{
                ...getStyles("singleValue", props),
              }}
            >
              <div>{supplier?.name}</div>
              <div css={accountRefCss}>{supplier?.account_reference}</div>
            </div>
          )
        },
        Option: props => {
          const { innerProps, innerRef, getStyles } = props
          const supplier = props.data as ISuppliers

          return (
            <div
              ref={innerRef}
              {...innerProps}
              style={{
                ...getStyles("option", props),
              }}
            >
              <div>{supplier?.name}</div>
              <div css={accountRefCss}>{supplier?.account_reference}</div>
            </div>
          )
        },
      }}
    />
  )
}
